import { Component, Input, OnInit } from '@angular/core';
import { Enums } from 'src/app/_models/generatedEnums';
import { PageElementViewModel, ConferenceViewModel, ConferenceViewModelWithDetails, EventViewModel, OrganizationViewModel, OrganizationEventSearchParams, EventOrderBy, TagViewModel } from 'src/app/_models/generatedModels';
import { OrganizationService } from 'src/app/_services/generatedServices';

@Component({
  selector: 'bxl-organization-event-listing',
  templateUrl: 'organization-event-listing.component.html',
})
export class OrganizationEventListingComponent implements OnInit {
  initialized = false;
  @Input() conference: ConferenceViewModel;
  @Input() organization: OrganizationViewModel;
  @Input() element: PageElementViewModel;
  searchParams: OrganizationEventSearchParams;
  EventOrderBy = EventOrderBy;
  OrderByEnum = Enums.EventOrderByEnum;
  events: EventViewModel[];
  tags: TagViewModel[];
  hideFilter: boolean;
  currentPage = 0;
  pageSize = 15;
  resultCount = 0;
  searching = false;

  rootRoute: string;
  constructor(private orgService: OrganizationService) {}

  ngOnInit(): void {
    this.searchParams = new OrganizationEventSearchParams();
    this.searchParams.courseEventStatus = null;
    this.searchParams.orderBy = EventOrderBy.EventDate;
    this.searchParams.roomId = null;
    this.searchParams.tag = null;

    var orgId = 0;
    if (this.conference) {
      orgId = this.conference.organizationId;
      this.rootRoute = '/conferences/' + this.conference.slug;
    } else {
      orgId = this.organization.id;
      this.rootRoute = '/organizations/' + this.organization.slug;
    }
    this.orgService.getTagsForOrganization(orgId.toString()).subscribe((tags) => {
      this.tags = tags;

      if (this.element.data) {
        try {
          var data = JSON.parse(this.element.data);
          console.log(data?.tag);
          this.searchParams.selectedDay = data?.selectedDay;
          this.searchParams.selectedTime = data?.selectedTime;
          this.searchParams.tag = data?.tag;

          if (this.searchParams.selectedDay || this.searchParams.selectedTime || this.searchParams.tag) {
            this.hideFilter = true;
          }
        } catch (e) {
          console.log('error');
          this.searchParams.selectedDay = null;
        }
      } else {
        this.searchParams.selectedDay = null;
      }

      this.search(true);

      this.initialized = true;
    });
  }

  search(resetPaging: boolean) {
    this.searching = true;
    if (resetPaging) {
      this.currentPage = 0;
    }
    this.events = [];

    this.orgService.searchEventsForOrganization(this.organization.id.toString(), this.currentPage, this.pageSize, true, this.searchParams).subscribe((pagedResult) => {
      this.currentPage = pagedResult.currentPage;
      this.pageSize = pagedResult.pageSize;
      this.resultCount = pagedResult.rowCount;
      this.events = pagedResult.results;

      this.initialized = true;
      this.searching = false;
    });
  }

  paginate(event) {
    //event.first = Index of the first record
    //event.rows = Number of rows to display in new page
    //event.page = Index of the new page
    //event.pageCount = Total number of pages
    this.currentPage = event.page;
    this.pageSize = event.rows;
    this.search(false);
  }
}
